import { Box, Chip } from '@mui/material';
import { useTranslate } from 'react-admin';
import { useWatch } from 'react-hook-form';
import { summaryStepChipStyles, summaryStepLayoutStyles } from '@/themes/commonStyles';

const SummaryStepDiscountInfo = () => {
    const translate = useTranslate();
    const discount = useWatch({ name: 'discount' }) || {};
    const discountType = discount?.type ?? 'fixed';
    const discountValue = discount?.fixedPercent ?? '';
    const depositTiers = Array.isArray(discount?.depositTiers) ? discount.depositTiers : [];
    const quantityTiers = Array.isArray(discount?.quantityTiers) ? discount.quantityTiers : [];

    if (discountType === 'fixed' && discountValue) {
        return <Chip label={translate('resources.campaign.labels.summary.discountFixed', { value: discountValue })} sx={summaryStepChipStyles.primary} />;
    }

    if (discountType === 'depositBased' && depositTiers.length > 0) {
        return (
            <Box sx={summaryStepLayoutStyles.flexRow}>
                {depositTiers
                    .filter(tier => tier.limit && tier.discount)
                    .map(tier => (
                        <Chip
                            key={`deposit-tier-${tier.limit}-${tier.discount}`}
                            label={translate('resources.campaign.labels.summary.depositTier', { limit: tier.limit, discount: tier.discount })}
                            sx={summaryStepChipStyles.primary}
                        />
                    ))}
            </Box>
        );
    }

    if (discountType === 'quantityBased' && quantityTiers.length > 0) {
        return (
            <Box sx={summaryStepLayoutStyles.flexRow}>
                {quantityTiers
                    .filter(tier => tier.limit && tier.value)
                    .map(tier => (
                        <Chip
                            key={`quantity-tier-${tier.limit}-${tier.value}`}
                            label={translate('resources.campaign.labels.summary.quantityTier', { limit: tier.limit, value: tier.value })}
                            sx={summaryStepChipStyles.primary}
                        />
                    ))}
            </Box>
        );
    }

    return null;
};

export default SummaryStepDiscountInfo;
